/**
 * @fileoverview A component which renders a actions in the file tree in a menu style.
 *
 * @author Justin Mancusi (jmancusi@yext.com)
 */

import {TreeNodeShape} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/nodes/shapesJsDoc';

import {MenuController} from '/ui/components/menu/menucontroller';
goog.require('yext');

/**
 * @param {{
 *   node: !TreeNodeShape,
 *   onAddOrUploadFiles: (function(string) | undefined),
 *   onAddDirectory: (function(string) | undefined),
 *   onDeleteFile: (function(TreeNodeShape) | undefined),
 *   onDeleteDirectory: (function(string) | undefined),
 *   onRenameFile: (function(TreeNodeShape) | undefined),
 *   onRenameDirectory: (function(string) | undefined),
 * }} props
 * @return {React.ReactNode}
 */
export const MenuActions = ({
  node,
  onAddOrUploadFiles,
  onAddDirectory,
  onRenameFile,
  onRenameDirectory,
  onDeleteFile,
  onDeleteDirectory,
}) => {
  /**
   * Returns an array of actions for the MenuController.
   * @return {!Array}
   */
  const getFileActions = () => {
    switch (node.type) {
      case 'blob': {
        const actions = [];
        if (onRenameFile) {
          actions.push({
            name: yext.msg('Rename'),
            callback: () => onRenameFile(node),
          });
        }
        if (onDeleteFile) {
          actions.push(
            {
              name: yext.msg('Delete'),
              destructive: true,
              callback: () => onDeleteFile(node),
            });
        }
        return actions;
      }
      case 'tree': {
        const actions = [];
        if (onAddOrUploadFiles) {
          actions.push({
            name: yext.msg('Add File'),
            callback: () => onAddOrUploadFiles(node.id),
          });
        }

        if (onAddDirectory) {
          actions.push({
            name: yext.msg('Add Folder'),
            callback: () => onAddDirectory(node.id),
          });
        }

        if (onRenameDirectory) {
          actions.push({
            name: yext.msg('Rename'),
            callback: () => onRenameDirectory(node.id),
          });
        }

        if (onDeleteDirectory) {
          actions.push(
            {
              name: yext.msg('Delete'),
              destructive: true,
              callback: () => onDeleteDirectory(node.id),
            });
        }
        return actions;
      }
      default: {
        return [];
      }
    }
  };

  return <MenuController actions={getFileActions()} isContextual={true} alignMenu={'left'}/>;
};
